import { SET_CONFIG, SET_CONFIG_ENVIRONMENT } from '../actions/actionTypes';

const initialState = {
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SET_CONFIG: {
    return {
      ...state,
      ...action.payload,
    };
  }

  case SET_CONFIG_ENVIRONMENT: {
    return {
      ...state,
      env: action.payload,
    };
  }

  default:
    return state;
  }
};
